// Single source of truth for the public, canonical site URL.
// Env-driven (REACT_APP_SITE_URL) with a safe default of the primary domain.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://kentucky.ie").replace(/\/+$/, "");
export const SITE_NAME = "Kentucky Horsewear Ireland | Boomerang.ie";

// Helper to build absolute, canonical URLs from a path.
export const absoluteUrl = (path = "/") => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
